<template>
  <div id="evaluate-question">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="wrapper">
      <div class="section section1">
        <div class="title">
          <span
            v-if="questionData[currentIndex].siteCategoryParentName">{{questionData[currentIndex].siteCategoryParentName + ' - (' + questionData[currentIndex].siteCategoryName + ')'}}</span>
          <span v-else>{{questionData[currentIndex].siteCategoryName}}</span>
        </div>
      </div>
      <div class="section section2">
        <div class="title">答题进度</div>
        <div class="progress">
          <div class="value" id="questionProgress"> > > > > > > > > > > > > > > > > > > > > > > > > > > > > > > > > > >
            > > > > > > > > > > > > > > </div>
          <div class="number" id="questionProgressNumber"></div>
        </div>
      </div>
      <div class="section section3">
        <div class="content">
          <div v-for="(value,index) in questionData[currentIndex].siteQuestionList" :key="index">
            <!--  1 单选题   -->
            <div class="que-box que-box-select" v-show="value.que_type===1">
              <div class="que-index">{{ index+1 +') '}}</div>
              <div class="que-title">{{value.que_content}}<span>(单选)</span></div>
              <div class="box-input" v-for="(item,ind) in value.siteQuestionAnswerList" :key="ind">
                <div class="que-value" @click="itemSelClick(value.siteQuestionAnswerList,item)">
                  <div class="image" :class="{'defaultImage': !item.isSel,'selImage': item.isSel}"></div>
                  <div class="value">{{item.answer_content}}</div>
                </div>
              </div>
            </div>
            <!--  2 多选题  3 问卷提  4 对象属性题   -->
            <div class="que-box que-box-select" v-show="value.que_type===2 || value.que_type===3 || value.que_type===4">
              <div class="que-index">{{ index+1 +') '}}</div>
              <div class="que-title">{{value.que_content}}<span>(多选)</span></div>
              <div class="box-input" v-for="(item,ind) in value.siteQuestionAnswerList" :key="ind">
                <div class="que-value" @click="itemMselClick(item)">
                  <div class="image" :class="{'defaultImage': !item.isSel,'selImage': item.isSel}"></div>
                  <div class="value">{{item.answer_content}}</div>
                </div>
              </div>
            </div>
            <!-- 5 输入框   -->
            <div class="que-box que-box-input" v-show="value.que_type===5">
              <div class="que-index">{{ index+1 +') '}}</div>
              <div class="que-title">{{value.que_content}}<span>(输入框)</span></div>
              <input :maxlength="value.maxlength"
                oninput="if(value.length == 1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/[^0-9]/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                v-model="value.que_value" v-on:blur="blur()" v-on:focus="focus()" />
            </div>
            <!-- 6 多选输入框 - 选最后一个 全取消  -->
            <div class="que-box que-box-select" v-show="value.que_type===6">
              <div class="que-index">{{ index+1 +') '}}</div>
              <div class="que-title">{{value.que_content}}<span>(多选加输入框)</span></div>
              <div class="box-input" v-for="(item,ind) in value.siteQuestionAnswerList" :key="ind">
                <div class="que-value" @click="itemMselInputClick(value.siteQuestionAnswerList,item,ind)">
                  <div class="image" :class="{'defaultImage': !item.isSel,'selImage': item.isSel}"></div>
                  <div class="value">{{item.answer_content}}</div>
                </div>
                <input :maxlength="value.maxlength" :placeholder="value.placeholder"
                  oninput="if(value.length == 1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/[^0-9]/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  v-model="item.que_value" v-show="item.isSel && ind+1 !== value.siteQuestionAnswerList.length"
                  v-on:blur="blur()" v-on:focus="focus()" />
              </div>
            </div>
            <!-- 7 输入框加子题目   -->
            <div class="que-box que-box-input" v-show="value.que_type===7">
              <div class="que-index">{{ index+1 +') '}}</div>
              <div class="que-title">{{value.que_content}}<span>(输入框)</span></div>
              <input :maxlength="value.maxlength" @keyup="ss(value)"
                oninput="if(value.length == 1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/[^0-9]/g,'')}"
                onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                v-model="value.que_value" v-on:blur="blur()" v-on:focus="focus()" />
              <div class="" v-show="value.show" v-for="(list,index) in value.subList" :key="index">
                <div class="que-title">{{list.que_content}}<span>(单选)</span></div>
                <div class="box-input" v-for="(item,ind) in list.siteQuestionAnswerList"
                  style="display:inline-block;margin-left: 35px;" :key="ind">
                  <div class="que-value" @click="itemSelClick(list.siteQuestionAnswerList,item)">
                    <div class="image" :class="{'defaultImage': !item.isSel,'selImage': item.isSel}"></div>
                    <div class="value">{{item.answer_content}}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 8 单选加输入框题  -->
            <div class="que-box que-box-select" v-show="value.que_type===8">
              <div class="que-index">{{ index+1 +') '}}</div>
              <div class="que-title">{{value.que_content}}<span>(单选加输入框)</span></div>
              <div class="box-input" v-for="(item,ind) in value.siteQuestionAnswerList" :key="ind">
                <div class="que-value" @click="itemSelClick(value.siteQuestionAnswerList,item)">
                  <div class="image" :class="{'defaultImage': !item.isSel,'selImage': item.isSel}"></div>
                  <div class="value">{{item.answer_content}}</div>
                </div>
                <input :maxlength="value.maxlength" :placeholder="value.placeholder"
                  oninput="if(value.length == 1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/[^0-9]/g,'')}"
                  onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                  v-model="item.que_value" v-show="item.isSel && ind+1 !== value.siteQuestionAnswerList.length"
                  v-on:blur="blur()" v-on:focus="focus()" />
              </div>
            </div>
            <!-- 9 单选加子题目  -->
            <div class="que-box que-box-select" v-show="value.que_type===9">
              <div class="que-index">{{ index+1 +') '}}</div>
              <div class="que-title">{{value.que_content}}<span>(单选加子题目)</span></div>
              <div class="box-input" v-for="(item,ind) in value.siteQuestionAnswerList" :key="ind">
                <div class="que-value" @click="itemSelClick(value.siteQuestionAnswerList,item)">
                  <div class="image" :class="{'defaultImage': !item.isSel,'selImage': item.isSel}"></div>
                  <div class="value">{{item.answer_content}}</div>
                </div>
                <div class="" v-show="item.isSel && ind+1 !== value.siteQuestionAnswerList.length"
                  v-for="(list,index) in value.subList" :key="index">
                  <span style="color: #000000;font-size: 16px;font-weight: bold">{{list.que_content}}</span>
                  <input :maxlength="value.maxlength"
                    onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                    onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                    v-model="list.que_value" v-on:blur="blur()" v-on:focus="focus()" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottomButton v-show="showBottom" id="bottomButton" title="下一步" :state="1" @click="bottomClick"></bottomButton>
  </div>
</template>

<script>
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button'
import { Toast } from 'mint-ui'
import wxShare from '../wx/weixin.js'
export default {
  data () {
    return {
      // 原始高度
      documentHeight: document.documentElement.clientHeight,
      // 实时屏幕高度
      showHeight: document.documentElement.clientHeight,
      // 是否显示底部按钮
      showBottom: true,
      currentIndex: 0,
      questionData: [
        []
      ],
      unfinishedCategoryIds: '' // 未完成答题的 三级 题目分类
    }
  },
  methods: {
    ss (value) {
      this.$set(value, 'show', value.que_value >= value.limit_number)
    },

    logoutClick: function () { // 退出登录
      this.$router.push({
        path: 'home'
      })
    },
    onResizeHeight: function () { // input  android 监听屏幕高度变化
      // window.onresize(function () {
      //   return (function () {
      //     this.showHeight = document.body.clientHeight
      //   })()
      // })
    },
    focus: function () {
      // if (!this.utils.isIphone()) {
      //   document.getElementById('bottomButton').style.display = 'none'
      // }
      document.getElementById('bottomButton').style.display = 'none'
    },
    blur: function () {
      document.getElementById('bottomButton').style.display = 'block'
      // if (this.utils.isIphone()) { // ios  iphone 适配键盘 弹出 回弹
      //   const currentScrollY = window.scrollY
      //   window.scrollTo(0, currentScrollY)
      // } else {
      //   document.getElementById('bottomButton').style.display = 'block'
      // }
    },
    questionProgress: function (click) {
      // 答题 进度
      let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      var _this = this
      //    console.log(userinfo)
      this.utils.GETHeader(this.accountUrl + '/riskeval/getProgress', {
        'phone': userinfo.tails.userinfo[0].phone
      }, function (response) {
        let data = response.data
        if (JSON.stringify(data) !== '{}') { // 评测进度
          // progress 0 初始化,提交了企业信息  1 完成二级答题 2 完成三级答题 3 完成评测
          let progressRate = data.progress_rate
          var width = progressRate * 0.01 * (document.body.clientWidth - 30)
          document.getElementById('questionProgress').style.width = width + 'px'
          document.getElementById('questionProgressNumber').innerText = data.progress_rate + '%'
          // if (click === 1) {
          let progress = data.progress
          if (progress === 0) {
            var categoryIds = ''
            for (let i = 0; i < data.tails.siteCategoryList.length; i++) {
              let catItem = data.tails.siteCategoryList[i]
              //  status 1 完成答题 2 未答题
              if (catItem.tails.status === 0) {
                categoryIds += (catItem.id + ',')
              }
            }
            // 有未完成的分类 答题
            if (categoryIds.length > 0) {
              if (categoryIds.indexOf(',') >= 0) {
                categoryIds = categoryIds.slice(0, categoryIds.length - 1)
              }
              // 提示有 未完成答题 提示 继续答题
              //            console.log('有未完成的评测 去完成=====================')
              _this.unfinishedCategoryIds = categoryIds
              _this.loadData()
            }
          }
          if (parseInt(progress) === 4) { // 三级评测 完成 去 完成评测
            //          console.log('完成所有 场所答题  去评测=======================')
            _this.$router.push({
              path: 'evaluate-question-risk'
            })
          }
          // }
        }
      })
    },
    itemSelClick: function (values, value) { // 单选
      for (let i = 0; i < values.length; i++) {
        let item = values[i]
        //      item.isSel = 0
        this.$set(item, 'isSel', 0)
        if (item.id === value.id) {
          this.$set(value, 'isSel', 1)
          //        value.isSel = 1
        }
      }
    },
    itemMselClick: function (value) { // 多选
      if (value.isSel === 0) {
        value.isSel = 1
      } else {
        value.isSel = 0
      }
    },
    itemMselInputClick: function (values, value, index) { // 多选 输入框
      if (values.length === index + 1) {
        for (let i = 0; i < values.length; i++) {
          let item = values[i]
          item.isSel = 0
          if (item.id === value.id) {
            value.isSel = 1
          }
        }
      } else {
        var item = values[values.length - 1]
        if (item.isSel === 1) {
          item.isSel = 0
        }
        if (value.isSel === 0) {
          value.isSel = 1
        } else {
          value.isSel = 0
        }
      }
    },
    bottomClick: function (type) { // 下一步
      //    console.log('=======================下一步')
      // 1 单选 2 3 4 多选  5输入框 6多选加输入框
      // 判断 答案是否 填写 完整
      for (var i = 0; i < this.questionData[this.currentIndex].siteQuestionList.length; i++) {
        var item = this.questionData[this.currentIndex].siteQuestionList[i]
        // 答案
        var userQuestionAnswerList = []
        // 单选 多选题
        if (item.que_type === 1 || item.que_type === 2 || item.que_type === 3 || item.que_type === 4 || item.que_type === 6) {
          // console.log('=======================单选题')
          for (var j = 0; j < item.siteQuestionAnswerList.length; j++) {
            // console.log('选项循环=======')
            var selItem = item.siteQuestionAnswerList[j]
            if (selItem.isSel) {
              var quevalueObj = {}
              if (item.que_type === 6 || item.que_type === 8) {
                // if (selItem.que_value.length <= 0 && (j !== item.siteQuestionAnswerList.length - 1)) {
                //   Toast('请完成答题')
                //   return
                // }
                if ((j !== item.siteQuestionAnswerList.length - 1)) {
                  if (selItem.que_value.length <= 0) {
                    Toast('请完成答题')
                    return
                  } else {
                    //                  console.log('6666================================' + selItem.que_value)
                    if (this.utils.isNumber(selItem.que_value) === false) {
                      Toast('请正确输入答题内容')
                      return
                    }
                  }
                }
                quevalueObj = {
                  'answer': selItem.answer_content,
                  'number': parseInt(selItem.que_value)
                }
              } else {
                quevalueObj = {
                  'answer': selItem.answer_content
                }
              }
              userQuestionAnswerList.push(quevalueObj)
            }
            if (j + 1 === item.siteQuestionAnswerList.length) {
              if (userQuestionAnswerList.length <= 0) {
                Toast('请完成答题')
                return
              } else {
                item.userQuestionAnswerList = userQuestionAnswerList
              }
            }
          }
        }
        if (item.que_type === 5 || item.que_type === 7) {
          //        console.log('=======================输入框' + item.que_value)
          if (item.que_value.length <= 0) {
            Toast('请完成答题')
            return
          } else {
            if (this.utils.isNumber(item.que_value) === false) {
              Toast('请正确输入答题内容')
              return
            }
            var quevalueObj2 = {
              'answer': parseInt(item.que_value)
            }
            userQuestionAnswerList.push(quevalueObj2)
            item.userQuestionAnswerList = userQuestionAnswerList
          }
        }
        if (item.que_type === 7) { // 如果是输入加单选，判断单选是否已选择
          if (item.show) {
            for (var l = 0; l < item.subList.length; l++) {
              var s = 0
              for (var k = 0; k < item.subList[l].siteQuestionAnswerList.length; k++) {
                var list = item.subList[l].siteQuestionAnswerList[k]
                if (list.isSel === undefined || list.isSel === 0) {
                  s = s + 1
                } else {
                  item.subList[l].userQuestionAnswerList = {
                    'answer': list.answer_content
                  }
                }
              }
              if (s === item.subList[l].siteQuestionAnswerList.length) {
                Toast('请完成答题')
                return
              }
            }
          }
        }
        if (item.que_type === 8) { // 单选加输入框
          for (var l = 0; l < item.siteQuestionAnswerList.length; l++) {
            if (item.siteQuestionAnswerList[l].isSel === 1) {
              if (item.siteQuestionAnswerList[l].answer_content === '有') {
                if (item.siteQuestionAnswerList[l].que_value === undefined || item.siteQuestionAnswerList[l].que_value === '') {
                  Toast('请完成答题')
                  return
                } else {
                  item.userQuestionAnswerList = [{
                    'answer': item.siteQuestionAnswerList[l].answer_content,
                    'number': item.siteQuestionAnswerList[l].que_value
                  }]
                }
              } else {
                item.userQuestionAnswerList = [{
                  'answer': item.siteQuestionAnswerList[l].answer_content
                }]
              }
            }
          }
          if (item.userQuestionAnswerList.length === 0) {
            Toast('请完成答题')
            return
          }
        }
        if (item.que_type === 9) { // 单选加子题目
          for (var l = 0; l < item.siteQuestionAnswerList.length; l++) {
            if (item.siteQuestionAnswerList[l].isSel === 1) {
              if (item.siteQuestionAnswerList[l].answer_content === '有') {
                for (var k = 0; k < item.subList.length; k++) {
                  if (item.subList[k].que_value === undefined || item.subList[k].que_value === '') {
                    Toast('请完成答题')
                    return
                  } else {
                    item.subList[k].userQuestionAnswerList = [{
                      'answer': item.subList[k].que_value
                    }]
                  }
                }
              }
              item.userQuestionAnswerList = [{
                'answer': item.siteQuestionAnswerList[l].answer_content
              }]
            }
          }
          if (item.userQuestionAnswerList.length === 0) {
            Toast('请完成答题')
            return
          }
        }
      }
      //    console.log(this.questionData[this.currentIndex])
      //    console.log(JSON.stringify(this.questionData[this.currentIndex]))
      let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      var questionArray = []
      questionArray.push(this.questionData[this.currentIndex])
      //    console.log(JSON.stringify(questionArray))
      // 提交 答题
      var _this = this
      console.log(questionArray)
      this.utils.POSTHeaderQS(this.accountUrl + '/riskevalNew/commitSiteQuestion', {
        'phone': userinfo.tails.userinfo[0].phone
      }, false, questionArray, function (response) {
        document.body.scrollTop = document.documentElement.scrollTop = 0
        // 当前最后 一套题
        _this.questionProgress()
      })
    },
    setListData: function () {
      //    console.log('000000000000数据同步====================111')
      this.$set(this.questionData[this.currentIndex].siteQuestionList, 'list', this.currentIndex)
    },
    loadData: function () {
      var _this = this
      // var categoryIds = this.$route.query.categoryIds
      //    this.utils.GET(this.accountUrl + '/riskevalNew/getQuestionBySite?siteCategoryIds=' + this.unfinishedCategoryIds, function (response) {
      this.utils.GET(this.accountUrl + '/riskevalNew/getQuestionBySite', function (response) {
        var result = response.data
        for (let i = 0; i < result.length; i++) {
          for (let j = 0; j < result[i].siteQuestionList.length; j++) {
            var que = result[i].siteQuestionList[j]
            // 单选题 选项题
            if (que.que_type === 1 || que.que_type === 2 || que.que_type === 3 || que.que_type === 4 || que.que_type === 6) {
              for (let k = 0; k < result[i].siteQuestionList[j].siteQuestionAnswerList.length; k++) {
                var item = result[i].siteQuestionList[j].siteQuestionAnswerList[k]
                // 初始化 选择状态 选项 答案
                item.isSel = 0
                item.que_value = ''
              }
            }
            // 输入框加单选题
            //          if (que.que_type === 7) {
            //            console.log(result[i].siteQuestionList[j],666666666)
            //          }
            // 输入题
            //          if (que.que_type === 5||que.que_type === 7) {
            //            // 初始化 答案字段
            //            que.que_value = ''
            //            switch (j) {
            //              case 0: que.maxLength = 6
            //                break
            //              case 1: que.maxLength = 2
            //                break
            //              case 2: que.maxLength = 5
            //                break
            //              default:
            //                break
            //            }
            //          }
          }
        }
        _this.questionData = result
        //      console.log(_this.questionData)
      })
    },
    binBack: function () {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', function () {
        history.pushState(null, null, document.URL)
      })
    }
  },
  watch: {
    $router () { },
    showHeight () {
      // if (this.documentHeight > this.showHeight) {
      //   this.showBottom = false
      // } else {
      //   this.showBottom = true
      // }
    }
  },
  computed: {},
  components: {
    mainHeader,
    bottomButton
  },
  mounted () {
    var _this = this
    this.utils.isUserLogin(function (login) {
      //    console.log('==========' + login)
      if (login === 0) {
        Toast('您还未登录，请登录后再评测！')
        _this.$router.push({
          path: 'home'
        })
      }
    })
    // 获取 未答题的分类
    this.unfinishedCategoryIds = this.$route.query.categoryIds
    //  this.loadData()
    this.onResizeHeight()
    this.binBack()
    setTimeout(function () {
      _this.questionProgress(0)
    }, 1000)
    // 微信 分享
    let imgUrl = 'http://cdn.zxzx119.com/39073939414056960'
    wxShare.wxRegister('消防安全风险评测', '中消在线风险评测  一站式解决企业风险隐患', imgUrl)
  }
}
</script>

<style scoped>
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.wrapper {
  background-color: #f4f4f4;
  /*height: 100%;*/
  margin-top: 55px;
  padding-bottom: 65px;
  overflow-scrolling: touch;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
}
.section {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ffffff;
}
.section .title {
  height: 50px;
  line-height: 50px;
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-left: 15px;
}
.section1 {
  height: 50px;
}
.section2 {
  height: 75px;
}
.section2 .title {
  text-align: center;
}
.section2 .progress {
  position: absolute;
  left: 15px;
  right: 15px;
  top: 50px;
  height: 8px;
  background-color: #eeeeee;
  border-radius: 4px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.19);
  overflow: hidden;
}
.section2 .progress .value {
  position: absolute;
  /*width: 100%;*/
  width: 0%;
  top: -2px;
  height: 10px;
  line-height: 10px;
  background-color: #c41335;
  color: #ffffff;
}
.section2 .progress .number {
  position: absolute;
  right: 5px;
  top: 2px;
  height: 7px;
  line-height: 7px;
  max-height: 7px;
  color: #808080;
  font-size: 10px;
}
.section3 {
  /*position: relative;*/
  min-height: 300px;
}
.section3 .content {
  /*margin: 0 15px;*/
}
.section3 .content .que-box {
  position: relative;
  width: 100%;
  min-height: 100px;
  /*height: auto;*/
  border-bottom: solid 10px #f4f4f4;
}
.section3 .content .que-box .que-index {
  position: relative;
  top: 15px;
  margin-left: 15px;
  margin-right: 15px;
  line-height: 25px;
  color: #000000;
  font-size: 16px;
  font-weight: bold;
}
.section3 .content .que-box .que-title {
  position: relative;
  top: -10px;
  /*margin-left: 15px;*/
  margin-left: 35px;
  margin-right: 15px;
  line-height: 25px;
  color: #000000;
  font-size: 16px;
  font-weight: bold;
}
.section3 .content .que-box .que-title span {
  top: 15px;
  margin-left: 5px;
  margin-right: 15px;
  line-height: 25px;
  color: #808080;
  font-size: 13px;
  font-weight: normal;
}
/* 输入 */
.section3 .content .que-box-input input {
  position: relative;
  margin-bottom: 25px;
  margin-top: 20px;
  margin-left: 35px;
  width: 70%;
  height: 35px;
  box-sizing: border-box;
  padding: 0 10px;
  /*background: yellow;*/
  border-radius: 0px;
  border: solid #eeeeee 1px;
}
/* 单选 多选 */
.section3 .content .que-box-select .box-input {
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 35px;
  line-height: 30px;
  /*background: yellow;*/
}
.section3 .content .que-box-select .box-input:nth-child(2) {
  margin-top: 30px;
  /*background-color: #FFEECC;*/
}
.section3 .content .que-box-select .box-input:last-of-type {
  margin-bottom: 25px;
}
.section3 .content .que-box .box-input .que-value {
  position: relative;
  color: #000000;
  font-size: 14px;
}
.section3 .content .que-box .box-input .image {
  position: relative;
  top: 0px;
  margin-left: 0px;
  height: 20px;
  width: 20px;
}
.section3 .content .que-box .box-input .value {
  position: relative;
  top: -20px;
  /*margin-left: 15px;*/
  margin-left: 30px;
  margin-right: 15px;
  line-height: 20px;
  color: #000000;
}
.defaultImage {
  background-image: url("../assets/radio_n.png");
  background-size: cover;
  background-position: center center;
}
.selImage {
  background-image: url("../assets/radio_s.png");
  background-size: cover;
  background-position: center center;
}
/* 多选 输入 */
.section3 .content .que-box-select .box-input input {
  position: relative;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 35px;
  width: 70%;
  height: 35px;
  border: solid #eeeeee 1px;
  box-sizing: border-box;
  padding: 0 10px;
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/view/evaluate-question.vue